var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C8.2652 0 8.5196 0.10536 8.7071 0.29289L15.7071 7.2929C16.0976 7.6834 16.0976 8.3166 15.7071 8.7071C15.3166 9.0976 14.6834 9.0976 14.2929 8.7071L9 3.41421V17C9 17.5523 8.5523 18 8 18C7.4477 18 7 17.5523 7 17V3.41421L1.70711 8.7071C1.31658 9.0976 0.68342 9.0976 0.29289 8.7071C-0.09763 8.3166 -0.09763 7.6834 0.29289 7.2929L7.2929 0.29289C7.4804 0.10536 7.7348 0 8 0Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/ArrowUp.618d39861d3d555e715561b610ec79d3.svg";
export { ForwardRef as ReactComponent };